import { combineReducers } from "redux";

// Reducers
import banners from "./banners";
import billingAddress from "./billingAddress";
import cart from "./cart";
import category from "./category";
import checkout from "./checkout";
import content from "./content";
import enews from "./enews";
import locations from "./locations";
import product from "./product";
import productVariant from "./productVariant";
import route from "./route";
import saleCodes from "./saleCodes";
import shippingAddress from "./shippingAddress";
import siteInfo from "./siteInfo";
import sort from "./sort";
import storeLocation from "./storeLocation";
import suggestedProducts from "./suggestedProducts";
import topTier from "./topTier";
import user from "./user";

// Custom
import jerseyForm from "./custom/jerseyForm";

import persist from "./persist";

// Combine reducers
const rootReducer = combineReducers({
	banners,
	billingAddress,
	cart,
	category,
	checkout,
	content,
	enews,
	locations,
	persist,
	product,
	productVariant,
	route,
	saleCodes,
	shippingAddress,
	siteInfo,
	sort,
	storeLocation,
	suggestedProducts,
	topTier,
	user,
	jerseyForm
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js